import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

const cn = (...cls) => cls.filter(Boolean).join(" ");

const Footer = () => {
  const location = useLocation();

  // Move WhatsApp up on product details (because you have bottom "Commander" bar)
  const isProductPage =
    location.pathname.startsWith("/product/") || location.pathname.startsWith("/products/");

  return (
    <>
      <footer className="bg-black text-white" style={{ fontFamily: "DM Sans, sans-serif" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Top */}
          <div className="py-12 border-b border-gray-800">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
              {/* Brand */}
              <div className="md:col-span-4">
                <div className="text-2xl font-extrabold tracking-widest uppercase">ORIMA</div>
                <p className="mt-3 text-sm text-gray-400 leading-6 max-w-sm">
                  Boutique premium au Maroc: sacs, montres et accessoires. Livraison gratuite en 1-2 jours.
                </p>
              </div>

              {/* Links */}
              <div className="md:col-span-5">
                <div className="text-sm font-bold text-gray-200 mb-4">Liens</div>
                <div className="grid grid-cols-2 gap-3 text-sm text-gray-400">
                  <Link to="/shop" className="hover:text-white transition-colors">
                    Boutique
                  </Link>
                  <Link to="/about" className="hover:text-white transition-colors">
                    À propos
                  </Link>
                  <Link to="/faq" className="hover:text-white transition-colors">
                    FAQ
                  </Link>
                  <Link to="/privacy" className="hover:text-white transition-colors">
                    Politique de confidentialité
                  </Link>
                  <Link to="/terms" className="hover:text-white transition-colors">
                    Conditions générales
                  </Link>
                </div>
              </div>

              {/* Social */}
              <div className="md:col-span-3">
                <div className="text-sm font-bold text-gray-200 mb-4">Suivez-nous</div>
                <div className="flex gap-3">
                  {/* Facebook */}
                  <a
                    href="https://www.facebook.com/profile.php?id=61583212417648"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h-11 w-11 rounded-2xl border border-gray-800 bg-black flex items-center justify-center text-gray-300 hover:text-white hover:border-gray-600 transition-all"
                    aria-label="Facebook"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
                    </svg>
                  </a>

                  {/* Instagram */}
                  <a
                    href="https://www.instagram.com/orima_ma/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h-11 w-11 rounded-2xl border border-gray-800 bg-black flex items-center justify-center text-gray-300 hover:text-white hover:border-gray-600 transition-all"
                    aria-label="Instagram"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                    </svg>
                  </a>

                  {/* TikTok */}
                  <a
                    href="https://www.tiktok.com/@orima.ma1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h-11 w-11 rounded-2xl border border-gray-800 bg-black flex items-center justify-center text-gray-300 hover:text-white hover:border-gray-600 transition-all"
                    aria-label="TikTok"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.17-2.89-.6-4.13-1.47V14.5c0 1.94-.41 3.94-1.63 5.46-1.57 2.05-4.3 3.01-6.76 2.58-2.61-.41-4.83-2.67-5.32-5.26-.58-3.08 1.14-6.39 4.16-7.39.54-.18 1.1-.3 1.67-.34V13.6c-.19.06-.38.13-.57.21-1.31.57-2.14 2.11-1.81 3.51.27 1.15 1.34 2.06 2.51 2.05 1.4-.04 2.53-1.33 2.51-2.73V.02z" />
                    </svg>
                  </a>
                </div>

                <div className="mt-5 text-xs text-gray-500">
                  Contact WhatsApp: <span className="text-gray-300 font-semibold">+212 613 305 292</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom */}
          <div className="py-6 flex flex-col sm:flex-row gap-3 items-center justify-between">
            <div className="text-xs text-gray-500 uppercase tracking-widest">
              © 2026 ORIMA STORE. Tous droits réservés.
            </div>

            <div className="flex items-center gap-3 text-xs text-gray-500">
              <Link to="/privacy" className="hover:text-white transition-colors">
                Politique
              </Link>
              <span className="text-gray-700">•</span>
              <Link to="/terms" className="hover:text-white transition-colors">
                Conditions
              </Link>
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button (moves up on product page) */}
      <a
        href="https://wa.me/212613305292"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact WhatsApp"
        className={cn(
          "fixed z-50 right-4 sm:right-6",
          isProductPage ? "bottom-24 sm:bottom-7" : "bottom-6 sm:bottom-7"
        )}
      >
        <div className="relative">
          {/* ring behind */}
          <span className="absolute inset-0 rounded-full bg-green-500/30 animate-ping" />

          {/* button */}
          <div className="relative h-14 w-14 rounded-full bg-green-500 text-white shadow-2xl flex items-center justify-center hover:bg-green-600 transition-transform active:scale-95 wa-wiggle">
            <FaWhatsapp className="w-7 h-7" />
          </div>
        </div>
      </a>

      <style>{`
        @keyframes waWiggle {
          0%, 100% { transform: rotate(0deg); }
          92% { transform: rotate(0deg); }
          94% { transform: rotate(-7deg); }
          96% { transform: rotate(7deg); }
          98% { transform: rotate(-5deg); }
        }
        .wa-wiggle { animation: waWiggle 3.5s ease-in-out infinite; }
      `}</style>
    </>
  );
};

export default Footer;
